// Single source of truth for every remote (Firestore `featureFlags`
// collection) flag this app reads, and the friendly keys consumers get back
// from `useRemoteFeatureFlags().flagsMap`. Add new remote flags here only.

export const REMOTE_FEATURE_FLAG_KEYS = {
  ONBOARDING_V5_ENABLED: 'ONBOARDING_V5_ENABLED',
  PAYMENT_LINK_V2_SIMPLIFIED_BILLING: 'PAYMENT_LINK_V2_SIMPLIFIED_BILLING',
  DISABLE_SIGNUP_ENABLED: 'DISABLE_SIGNUP_ENABLED',
} as const;

export interface RemoteFlagsMap {
  onboardingV5Enabled: boolean;
  paymentLinkV2SimplifiedBilling: boolean;
  isSignUpDisabled: boolean;
}

export const buildRemoteFlagsMap = (
  isFeatureEnabled: (key: string) => boolean,
): RemoteFlagsMap => ({
  onboardingV5Enabled: isFeatureEnabled(
    REMOTE_FEATURE_FLAG_KEYS.ONBOARDING_V5_ENABLED,
  ),
  paymentLinkV2SimplifiedBilling: isFeatureEnabled(
    REMOTE_FEATURE_FLAG_KEYS.PAYMENT_LINK_V2_SIMPLIFIED_BILLING,
  ),
  isSignUpDisabled: isFeatureEnabled(
    REMOTE_FEATURE_FLAG_KEYS.DISABLE_SIGNUP_ENABLED,
  ),
});
